// Request actions
export const QUERY_REQUEST_SENT = 'QUERY_REQUEST_SENT' as const;
export const MUTATION_REQUEST_SENT = 'MUTATION_REQUEST_SENT' as const;

// Response actions
export const QUERY_RESPONSE_RECEIVED = 'QUERY_RESPONSE_RECEIVED' as const;
export const MUTATION_RESPONSE_RECEIVED = 'MUTATION_RESPONSE_RECEIVED' as const;

// Requirement actions
export const QUERY_REQUIRED = 'QUERY_REQUIRED' as const;
export const QUERY_NOT_REQUIRED = 'QUERY_NOT_REQUIRED' as const;
export const MUTATION_REQUIRED = 'MUTATION_REQUIRED' as const;

// Network polling and request limits
export const INITIAL = 'INITIAL';
export const MAX_FLIGHTS_PRICING_MUTATION_REQUESTS = 5;
export const MAX_FLIGHTS_PRICING_QUERY_REQUESTS = 4;
export const MAX_SONAR_POLLING_REQUESTS = 1;
export const MAX_SONAR_5XX_POLLING_REQUESTS = 4;
export const MAX_FLIGHTS_PRICING_QUERY_SLOW_REQUESTS = 2;
export const MAX_RADAR_MUTATION_REQUESTS = MAX_FLIGHTS_PRICING_MUTATION_REQUESTS;
export const MAX_RADAR_QUERY_REQUESTS = MAX_FLIGHTS_PRICING_QUERY_REQUESTS;
export const MAX_RANK_EXPLAINABILITY_REQUESTS = 4;
export const MAX_PARTNER_METADATA_REQUESTS = 4;
export const MAX_PAYMENT_DISCOUNT_REQUESTS = 4;
export const MAX_LOYALTY_DISCOUNTS_REQUESTS = 4;
export const MAX_PRICE_PULSE_REQUESTS = 4;
export const MAX_PRICE_PULSE_ITINERARIES = 100;
export const MAX_PRICE_PULSE_DISPLAY = 3;
export const MAX_SESSION_AGE = 60 * 60 * 1000; // 1 hour
